<template>
  <div>
    <div>
      <searchCpn :cpnShow="true" :cpnName="showText" :levelShow="true" @handleQuery="handleQuery"/>
    </div>
    <div v-show="!showDetaiTable">
      <div class="page_container">
        <el-table :size="size" :data="list1" v-loading="loading1">
          <el-table-column :label="$t('fuelEfficientDriving.评分排名')" prop="RankID" align="center" min-width=""></el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.车辆')" prop="CarNo" align="center" min-width=""></el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.评分等级')" prop="RankName" align="center" min-width="">
            <template slot-scope="scope">
              {{getText(scope.row.Score)}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.平均分')" prop="Score" align="center" min-width=""></el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.操作')" prop="" align="center" min-width="">
            <template slot-scope="scope">
              <span style="color:#3983ff;cursor: pointer;" @click="getDetail1(scope.row)">{{$t('public.Detail')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <kl-pagination  :total="total1" @current-change="pageChange1" :pageSize="pageSize" :currentPage="currentPage1"></kl-pagination>
      </div>
    </div>
    <div v-show="showDetaiTable">
      <div style="display:flex;align-items:center;">
        <div v-if="vehicles == ''">    
          <el-button 
            icon="el-icon-arrow-left"
            :size="size"
            style="margin-left:8px;"
            @click="goBackAll"
          >{{ $t("driver.返回")}}</el-button>
        </div>
        <div style="display: flex;margin:12px">
          <div class="title" style="color: #81889c;">{{$t('fuelEfficientDriving.车辆明细')}}</div>
          <div class="title">
            <i class="el-icon-arrow-right icon_right"></i>
          </div>
          <div class="title" style="color: #0f1a3a;">{{$t('fuelEfficientDriving.单车行程明细')}}</div>
        </div>
      </div>
      <div class="page_container">
        <el-table :size="size" :data="list2" v-loading="loading2">
          <el-table-column :label="$t('fuelEfficientDriving.车辆')" prop="CarNo" align="center" min-width=""></el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.评分等级')" prop="RankName" align="center" min-width="">
            <template slot-scope="scope">
              {{getText(scope.row.Score)}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.车辆驾驶评分')" prop="Score" align="center" min-width=""></el-table-column>
          <el-table-column align="center" :label="$t('fuelEfficientDriving.驾驶时段')" min-width="">
            <template slot-scope="scope">{{scope.row.AcconTime.substring(5)}}~{{scope.row.AccOffTime.substring(5)}}</template>
          </el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.百公里油耗')+'(L)'" align="center" min-width="">
            <template slot-scope="scope">{{getOilConsumptionPer100km(scope.row.OilConsume,scope.row.RunMileage)}}</template>
          </el-table-column>
          <el-table-column :label="$t('fuelEfficientDriving.操作')" prop="" align="center" min-width="">
            <template slot-scope="scope">
              <span style="color:#3983ff;cursor: pointer;" @click="getDetail2(scope.row)">{{$t('public.Detail')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <kl-pagination  :total="total2" @current-change="pageChange2" :pageSize="pageSize" :currentPage="currentPage2"></kl-pagination>
      </div>
    </div>
    <score_detail  ref="model"></score_detail>
  </div>
</template>
<script>
import score_detail from "@/views/driver/fuel_efficient_driving/score_detail/index.vue"
import searchCpn from "@/views/driver/fuel_efficient_driving/components/searchCpn.vue"
import { mapState } from 'vuex'
export default {
  components:{searchCpn,score_detail},
  props:{
    cpnName: {
      type: String,
      default: "",
    },
  },
  data() {
    return{
      showText:{
        title:"参评企业:",
        text:"",
      },
      loading1:false,
      loading2:false,
      beginDate:"",
      endDate:"",
      vehicles:"",
      level:"",
      dataList1:"",
      dataList2:"",
      total1:0,
      total2:0,
      currentPage1:1,
      currentPage2:1,
      pageSize:10,
      showDetaiTable:false,
      vehiclesTemp:"",
    }
  },
  computed:{
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    list1(){
      if(this.dataList1 != null && this.dataList1.length > 0){
        return this.dataList1.slice((this.currentPage1 - 1) * this.pageSize,this.currentPage1 * this.pageSize)
      }
      return [];
    },
    list2(){
      if(this.dataList2 != null && this.dataList2.length > 0){
        return this.dataList2.slice((this.currentPage2 - 1) * this.pageSize,this.currentPage2 * this.pageSize)
      }
      return [];
    },
  },
  watch: {
    cpnName(newVal, oldVal) {
      this.showText.text = this.cpnName;
    },
  },
  mounted(){
  },
  methods:{
    getText(score){
      if(score<=100 && score >= 90){
        return this.$t('fuelEfficientDriving.优秀');
      }else if(score < 90 && score >= 80){
        return this.$t('fuelEfficientDriving.良好');
      }else if(score < 80 && score >= 70){
        return this.$t('fuelEfficientDriving.中等');
      }else if(score < 70 && score >= 60){
        return this.$t('fuelEfficientDriving.一般');
      }else if(score < 60 && score >0){
        return this.$t('fuelEfficientDriving.差');
      }else{
        return this.$t('fuelEfficientDriving.差');
      }
    },
    goBackAll(){
      this.showDetaiTable = false;
    },
    getOilConsumptionPer100km(energy,mileage){
      //计算百公里能耗，总能耗/公里数*100 
      if(mileage == null || mileage == 0 || mileage < 2) return 0;
      return Number((energy/mileage*100).toFixed(2));
    },
    getDetail1(row){
      this.showDetaiTable = true;
      this.vehiclesTemp = row.VehicleID;
      this.getData2(row.VehicleID);
    },
    getDetail2(row){
      let params = {
        carNo: row.CarNo, 
        score: row.Score,
        rankName:row.RankName,
        mileage:row.RunMileage,
        oilConsume: row.OilConsume,
        acconTime:row.AcconTime,
        accoffTime:row.AccOffTime,
        vehicleID:this.showDetaiTable ? this.vehiclesTemp : this.vehicles,
        showDate:[row.AcconTime.substring(5,16),row.AccOffTime.substring(5,16)]
      }
      this.$refs.model.allInit(params);
    },
    pageChange1(page) {
      this.currentPage1 = page;
    },
    pageChange2(page) {
      this.currentPage2 = page;
    },
    handleQuery(val){
      // console.log(val);
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      this.level = val.level;
      this.vehicles = this.getSelectedVehicles();
      if (this.vehicles == "") {
        this.showText.title = this.$t('fuelEfficientDriving.参评企业')+":";
        this.showText.text = this.cpnName;
        this.getData1();
        this.showDetaiTable = false;
      } else {
        this.vehicleName = this.vehicleName.substring(0,this.vehicleName.length - 1);
        this.showText.title = this.$t('fuelEfficientDriving.参评车辆')+":";
        this.showText.text = this.vehicleName;
        this.getData2();
        this.showDetaiTable = true;
      }
    },
    getData1(){
      this.loading1 = true;
      this.$api.queryFuelEffiGradeScoreRankings({
        OperatorID: this.$store.getters.operator.OperatorId + "",
        BeginDate: this.beginDate, 
        EndDate: this.endDate,
        QueryInfo: this.vehicles,
        RankName: this.level,
      })
      .then((res)=>{
        this.dataList1 = res.data;
        this.total1 = res.recordsTotal;
        this.loading1 = false;
      })
      .catch((e)=>{
        this.dataList1 = [];
        this.total = 0;
        this.loading1 = false;
      })
    },
    getData2(fromDetailVehicles){
      this.loading2 = true;
      this.$api.queryFuelEffiGradeScoreRunRec({
        OperatorID: this.$store.getters.operator.OperatorId + "",
        BeginDate: this.beginDate, 
        EndDate: this.endDate,
        VehicleID: fromDetailVehicles ? fromDetailVehicles+'' : this.vehicles,
        rankName: this.level,
      })
      .then((res)=>{
        this.dataList2 = res.data;
        this.total2 = res.recordsTotal;
        this.loading2 = false;
      })
      .catch((e)=>{
        this.dataList2 = [];
        this.total2 = 0;
        this.loading2 = false;
      })
    },
    getSelectedVehicles() {
      this.vehicles = "";
      this.vehicleName = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles =
            this.vehicles + this.selectedVehicles[k].nodeValue + ",";
          this.vehicleName =
            this.vehicleName + this.selectedVehicles[k].vehicleName + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
  },
}
</script>
<style scoped lang="scss">
.title{
font-weight: 600;font-size: 14px;
}
.page_container {
    margin-top: 10px;

   .el-table tr {
        background: transparent;
    }

  .el-table {
        background: transparent;
    }

    .el-table td {
        background: transparent;
    }
} 
.detailStyle{
  ::v-deep .el-dialog__header{
    background: #f4f8ff;
  }
  ::v-deep .el-dialog__body{
    background: #f4f8ff;
    height: 96% !important;
  }
}
</style>